import isEqualWith from 'lodash/isEqualWith'
import isObject from 'lodash/isObject'
import isArray from 'lodash/isArray'
import keys from 'lodash/keys'
import union from 'lodash/union'
import isNull from 'lodash/isNull'

function formDataComparator(value1, value2) {
  //
  // Rule 1: null and empty array are considered equal
  // because when we send an empty array to the backend, it is stored as null, and then returned as null
  if (isNull(value1) && Array.isArray(value2) && value2.length === 0) {
    return true
  }
  if (isNull(value2) && Array.isArray(value1) && value1.length === 0) {
    return true
  }

  // Rule2: integer and their string representation are considered equal
  if (
    (typeof value1 === 'number' && typeof value2 === 'string' && String(value1) === value2) ||
    (typeof value2 === 'number' && typeof value1 === 'string' && String(value2) === value1)
  ) {
    return true
  }

  // by default, use lodash isEqual
  return undefined
}

export function areFormDataLooselyEqual(obj1, obj2) {
  return isEqualWith(obj1, obj2, formDataComparator)
}

/**
 * Recursively collect all differences between two values.
 * Returns an array of objects: { path, initial, current }.
 *
 * For debug only
 */
export function findAllDifferences(initial, current) {
  const diffs = []

  function recurse(a, b, path) {
    // identical -> nothing to report
    if (areFormDataLooselyEqual(a, b)) return

    // If either side is not an object/array, it's a leaf difference
    if (!isObject(a) || !isObject(b) || isArray(a) || isArray(b)) {
      diffs.push({ path: path || '', initial: a, current: b })
      return
    }

    // both are plain objects -> iterate all keys
    const allKeys = union(keys(a), keys(b))
    for (let k of allKeys) {
      const nextPath = path ? `${path}.${k}` : `${k}`
      recurse(a ? a[k] : undefined, b ? b[k] : undefined, nextPath)
    }
  }

  recurse(initial, current, '')
  return diffs
}
